import type { IGenericTableRowFormatting } from '@/interfaces/powerMarkets/table/IGenericTableRowFormatting.ts';
import type { IGenericTableRowData } from '@/interfaces/powerMarkets/table/IGenericTableRowData.ts';

function isMeaningfulCell (cell: IGenericTableRowFormatting): boolean {
    return !cell.hideEntry && !cell.cellFormatProperties?.hideCell
        && (cell.cellFormatProperties?.columnSpan ?? 1) === 1
        && cell.values.some(value => value !== null && value !== '' && value !== '-');
}

export function getColumnAlignments (rows: IGenericTableRowData[], headerIds: string[]): Record<string, string> {
    return Object.fromEntries(headerIds.map(id => {
        const cells = rows.map(row => row.row[id]).filter(cell => cell && isMeaningfulCell(cell));
        const override = cells[0]?.cellFormatProperties?.textAlign;
        if (override && cells.every(cell => cell.cellFormatProperties?.textAlign === override)) return [id, override];
        return [id, cells.length && cells.every(cell => cell.cellType === 'number') ? 'right' : 'left'];
    }));
}
